.container {
    display: flex;
    flex-direction: column;
}

.info-link {
    padding-top: 20px;
    align-self: center;
}
